export default __webpack_public_path__ + "static/media/DOM-OCT2026.adebe31c.png";